module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "majors"
    },
    on: {
      "click": function($event) {
        _vm.searching = false
      }
    }
  }, [_c('div', {
    staticClass: "ds-main ds-background",
    attrs: {
      "id": "landing-hero"
    }
  }, [_c('div', {
    attrs: {
      "id": "landing"
    }
  }, [_c('h1', [_vm._v("Find Your Degree")]), _vm._v(" "), _c('h2', [_vm._v("Explore our many programs of study to find the one that best fits you.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-links"
    }
  }, [_c('div', {
    staticClass: "search-link-column",
    class: {
      collegeview: _vm.showCollegeView
    }
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    }
  }, [_vm._v("\n            All " + _vm._s(_vm.programNaming) + "s\n          ")])], 1), _vm._v(" "), (_vm.showCollegeView) ? _c('div', {
    staticClass: "search-link-column",
    class: {
      collegeview: _vm.showCollegeView
    }
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'collegeSearch'
      }
    }
  }, [_vm._v("\n            Select by College\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-link-column keyword-search",
    class: {
      collegeview: _vm.showCollegeView
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.searching = true
      }
    }
  }, [(_vm.searching) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "searchBox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._m(0)]) : _c('a', {
    staticClass: "ds-main ds-color-hover search-link"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v("\n            Find by Keyword\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-link-column",
    class: {
      collegeview: _vm.showCollegeView
    }
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    }
  }, [_vm._v("\n            Search by Interest\n          ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce48601","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Landing.vue
// module id = 996
// module chunks = 1